import { NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ChangeDetectorRef
} from '@angular/core';
import { MatOptionModule } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SharedModule } from 'app/shared/shared.module';

export interface Customer {
  id: string;
  name: string;
  displayName: string;
}

@Component({
  selector: 'app-customer-selector',
  templateUrl: './customer-selector.component.html',
  styleUrls: ['./customer-selector.component.scss'],
  standalone: true,
  imports: [
    MatOptionModule,
    MatSelectModule,
    MatIcon,
    NgClass,
    MatFormFieldModule,
    SharedModule
  ]
})
export class CustomerSelectorComponent implements OnInit {
  customers: Customer[] = [
    { id: 'evle', name: 'EVLE', displayName: 'EVLE' },
    { id: 'halt', name: 'HALT', displayName: 'HALT' },
    { id: 'henry', name: 'HENRY', displayName: 'HENRY' },
    { id: 'hpwtx', name: 'HPWTX', displayName: 'HPWTX' },
    { id: 'walla', name: 'WALLA', displayName: 'WALLA' }
  ];

  selectedCustomer: Customer | null = null;
  loading: boolean = false;

  @Output() customerSelected = new EventEmitter<{ id: string; name: string }>();

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.initializeCustomer();
  }

  /**
   * Initialize with WALLA as default selection
   */
  initializeCustomer(): void {
    // Select WALLA as default
    const defaultCustomer = this.customers.find(
      customer => customer.id === 'walla'
    );

    if (defaultCustomer) {
      this.selectedCustomer = defaultCustomer;
      this.onCustomerChange(defaultCustomer.id);
    }
  }

  /**
   * Handle customer selection change
   */
  onCustomerChange(customerId: string): void {
    const selectedCustomer = this.customers.find(
      customer => customer.id === customerId
    );

    if (selectedCustomer) {
      this.selectedCustomer = selectedCustomer;
      this.customerSelected.emit({
        id: selectedCustomer.id,
        name: selectedCustomer.name
      });
    }
  }

  /**
   * Force change detection to update the view
   */
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
  }
}
